const maxDrawAmount = (netFunding: number, maxDrawPercentage: number): number =>
  Math.round((netFunding || 0) * (maxDrawPercentage ?? 0) * 100) / 100;

/** null or "No" is No. Any other value, including "", is Yes. */
const loanLabel = (
  borrowerAdvance: string | null | undefined
): 'Yes' | 'No' => {
  if (borrowerAdvance == null || borrowerAdvance === 'No') {
    return 'No';
  }
  return 'Yes';
};

const interestPayerChoices = [
  { value: 'Borrower', label: 'Borrower' },
  { value: 'Installer', label: 'Contractor' },
] as const;

/** Borrower stays. Installer and Consultant display as Contractor. */
const paymentsMadeByLabel = (
  payer: string | null | undefined
): 'Borrower' | 'Contractor' | null => {
  if (payer === 'Borrower') {
    return 'Borrower';
  }
  if (['Installer', 'Consultant'].includes(payer ?? '')) {
    return 'Contractor';
  }
  return null;
};

export const Milestone = {
  maxDrawAmount,
  loanLabel,
  interestPayerChoices,
  paymentsMadeByLabel,
};
